import { useMemo, useState } from "react";
import styled, { css } from "styled-components";

const ContentFrame = styled.div`
width: 100%;
display: flex;
flex-direction: column;
gap: 80px;
@media (max-width: 767px) {
  gap: 36px;
}
`;

const InfoFrame = styled.div`
width: 100%;
border: 1px solid #99a5ac;
border-radius: 8px;
background-color: #f3f7fd;
display: flex;
flex-direction: column;
`;

const InfoTopFrame = styled.div`
width: 100%;
border-bottom: solid 1px #ddd;
padding: 30px;
display: flex;
flex-direction: column;
gap: 10px;
@media (max-width: 1099px) {
  padding: 20px;
}
`;

const InfoBottomFrame = styled.div`
width: 100%;
padding: 20px 30px;
display: flex;

align-items: center;
@media (max-width: 1099px) {
  padding: 12px 20px;
}
`;

const InfoTitle = styled.div`
font-family: Gongim-Medium;
font-size: 20px;
color: #222;
text-align: left;
@media (max-width: 1099px) {
  font-size: 16px;
}
`;

const InfoContents = styled.div`
font-family: Gongim-Reguler;
font-size: 18px;
color: #707070;
line-height: 160%;
text-align: left;
@media (max-width: 1099px) {
  font-size: 14px;
}
`;
const CheckClickFrame = styled.div`
display: flex;
gap: 10px;
align-items: center;
`;

const CheckOffFrame = styled.div`
width: 24px;
height: 24px;
background-color: #d9d9d9;
border-radius: 99px;
border: solid 1px #aaaaaa;
@media (max-width: 1099px) {
  width: 18px;
  height: 18px;
}
`;


const CheckOnFrame = styled.img`
width: 24px;
@media (max-width: 1099px) {
  width: 18px;
}
`;

const CheckText = styled.div`
font-family: Gongim-Medium;
font-size: 20px;
color: #707070;
@media (max-width: 1099px) {
  font-size: 16px;
}
`;


const SubContentFrame = styled.div`
display: flex;
flex-direction: column;
gap: 30px;
@media (max-width: 1099px) {
  gap: 10px;
}
`;
const SubTitleFrame = styled.div`
display: flex;
justify-content: space-between;
`;
const SubTitle = styled.div`
font-family: Gongim-Medium;
font-size: 32px;
@media (max-width: 1099px) {
  font-size: 18px;
}
`;
const CallFrame = styled.div`
border-radius: 99px;
padding-right: 20px;
height: 42px;
background-color: #349dec;
display: flex;
justify-content: start;
align-items: center;
gap: 8px;
@media (max-width: 1099px) {
  height: 26px;
  gap: 3px;
  padding-right: 10px;
  margin-top: -2px;
}
`;

const CallText = styled.div`
font-family: Gongim-Medium;
font-size: 20px;
color: #fff;
@media (max-width: 1099px) {
  font-size: 15px;
}
`;
const CallText02 = styled.div`
font-family: Gongim-Medium;
font-size: 20px;
color: #fff;
@media (max-width: 1099px) {
  display: none;
}
`;

const Call = styled.img`
height: 100%;
`;

const TableFrame = styled.div`
width: 100%;
display: flex;
flex-direction: column;
border-top: solid 2px #99a5ac;
box-sizing: content-box;
`;

const TableRow = styled.div`
width: 100%;
border-bottom: solid 2px #ddd;
box-sizing: content-box;
padding: 28px 0;
display: flex;
justify-content: start;
gap: 80px;

@media (max-width: 767px) {
  border-bottom: none;
  flex-direction: column;
  padding: 0;
  gap: 0px;
}
`;
const TableGroup = styled.div`
width: 510px;
display: flex;
justify-content: start;
align-items: center;
@media (max-width: 1099px) {
  width: 100%;
}
@media (max-width: 767px) {
  padding: 28px 0;
  border-bottom: solid 2px #ddd;
}
`;

const TableLeftTitle = styled.div`
width: 150px;
font-family: Gongim-Medium;
font-size: 20px;
text-align: left;
color: #333;
${(props) =>
    props.vali ?
      css`
    color: #EB3F3D;
  ` :
      css`
    color: #333;
  `
  }
@media (max-width: 1099px) {
  width: 104px;

  font-size: 16px;
}
`;

const RadioFrame = styled.div`
display: flex;
gap: 40px;
@media (max-width: 767px) {
  flex-direction: column;
  gap: 16px;
}
`;

const RadioContentFrame = styled.div`
display: flex;
align-items: center;
gap: 10px;
`;

const RadioOn = styled.div`
width: 24px;
height: 24px;
background-color: #fff;
border: 6px solid #585858;
border-radius: 99px;
@media (max-width: 1099px) {
  width: 16px;
  height: 16px;
  border: 4px solid #585858;
}
`;

const RadioOff = styled.div`
width: 24px;
height: 24px;
background-color: #d9d9d9;
border: 1px solid #aaa;
border-radius: 99px;
@media (max-width: 1099px) {
  width: 16px;
  height: 16px;
}
`;

const RadioText = styled.div`
font-family: Gongim-Reguler;
font-size: 18px;
color: #707070;
@media (max-width: 1099px) {
  font-size: 15px;
}
`;

const TextInfut = styled.input`
width: 260px;
height: 40px;
padding: 0 20px;
border: 1px solid #707070;
color: #333;
font-family: Gongim-Medium;
font-size: 16px;
${(props) =>
    props.vali === true ?
      css`
    border: 1px solid #EB3F3D;
    color: #EB3F3D;
  ` :
      css`
    border: 1px solid #707070;
    color: #333;
  `
  }
@media (max-width: 1099px) {
  border-radius: 0;
  height: 36px;
  flex: 1;
  font-size: 14px;
  padding: 0 12px;
}
`;

const CarImg = styled.img`
width: 22px;
@media (max-width: 1099px) {
  width: 18px;
}
`;

const ButtonLine = styled.div`
width: 100%;
display: flex;
justify-content: center;
gap: 20px;
padding: 0 0 80px 0;
@media (max-width: 1099px) {
  gap: 10px;
  padding: 36px 0;
}
`;

const ButtonRed = styled.div`
width: 230px;
height: 50px;
border-radius: 4px;
display: flex;
justify-content: center;
align-items: center;
background-color: #eb3f3d;
color: #fff;
font-family: Gongim-Medium;
font-size: 20px;
@media (max-width: 1099px) {
  flex: 1;
  height: 40px;
  font-size: 18px;
}
`;

const ButtonBack = styled.div`
width: 230px;
height: 50px;
border-radius: 4px;
border: 1px solid #707070;
display: flex;
justify-content: center;
align-items: center;
background-color: #fff;
color: #707070;
font-family: Gongim-Medium;
font-size: 20px;
@media (max-width: 1099px) {
  flex: 1;
  height: 40px;
  font-size: 18px;
}
`;
const RightRowFrame = styled.div`
  display: flex;

  flex: 1;
`;
const RightMedium = styled.div`
  font-family: Gongim-Medium;
  font-size: 18px;
  color: #333;
  @media (max-width: 1099px) {
    font-size: 15px;
  }
`;
const RightReguler = styled.div`
  font-family: Gongim-Reguler;
  font-size: 18px;
  color: #333;
  @media (max-width: 1099px) {
    font-size: 15px;
  }
`;
const RightColFrame = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  @media (max-width: 1099px) {
    gap: 10px;
  }
`;
const PayTitle = styled.div`
  font-family: Gongim-Medium;
  font-size: 32px;
  @media (max-width: 1099px) {
    font-size: 28px;
  }
`;
const RedTitle = styled.div`
  font-family: Gongim-Reguler;
  font-size: 16px;
  color: #eb3f3d;
  text-align: left;
  @media (max-width: 1099px) {
    font-size: 12px;
  }
`;
const WordSkip = styled.div`
  @media (min-width: 1100px) {
    display: none;
  }
`;
const RightMedium86px = styled.div`
  width: 86px;
  font-family: Gongim-Medium;
  font-size: 18px;
  color: #333;
  text-align: left;
  @media (max-width: 1099px) {
    font-size: 15px;
    width: 72px;
  }
`;
const RightColFrameMini = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
const RightRegulerMini = styled.div`
  font-family: Gongim-Reguler;
  font-size: 16px;
  color: #707070;
  text-align: left;
  @media (max-width: 1099px) {
    font-size: 12px;
  }
`;





export default function Content04(payLoad) {
  const [payload, setPayload] = useState(payLoad.payload);
  const [cardPayload, setCardPayload] = useState(payLoad.cardPayload);
  const [loading, setLoading] = useState(false);
  const [errorText, setErrorText] = useState('');

  // const _remark = useMemo(() => payload.remark.split(" "), [payload]);
  // const remark = payload.remark.split(" ");
  // const defaultPrice = Number(remark[1].split(":")[1].split(",")[0]);
  // const emergency = Number(remark[2].split(":")[1].split(",")[0]);
  // const outBack = Number(remark[3].split(":")[1].split(",")[0]);
  // const danger = Number(remark[4].split(":")[1].split(",")[0]);

  const cardNo = useMemo(() => cardPayload.memo.split(" ")[2].split(",")[0]);
  const replacePrice = (str) => {
    const comma = (str) => {
      str = String(str);
      return str.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, "$1,");
    };
    const uncomma = (str) => {
      str = String(str);
      return str.replace(/[^\d]+/g, "");
    };
    return comma(uncomma(str));
  }
  return (
    <ContentFrame>
      <InfoFrame style={{ backgroundColor: "#fff", border: "0" }}>
        { cardPayload.state === 10332 ?
            <>
              <InfoTitle style={{ fontSize: "18px" }}>운행에 대한 결제를 완료 했습니다. <WordSkip /> (결제 완료)</InfoTitle><br />
            </>
          :
            <>
              <InfoTitle style={{ fontSize: "18px" }}>결제를 진행하던 도중 문제가 발생하였습니다. <WordSkip /> ({ cardPayload.message })</InfoTitle><br />
            </>
        }
        <TableGroup style={{ width: "auto", padding: "0", borderBottom: "0" }}>
          <TableLeftTitle style={{ width: "90px", fontSize: "18px" }}>결제 금액 :</TableLeftTitle>
          <RightColFrame style={{ marginBottom: "10px" }}>
            <RightRowFrame style={{ gap: "10px", alignItems: "flex-end" }}>
              <RightRowFrame style={{ alignItems: "flex-end" }}>
                <PayTitle style={{ fontSize: "36px", color: "#EB3F3D" }}>{replacePrice(payload.payAmount)}</PayTitle>
                <RightMedium style={{ marginBottom: "4px", color: "#EB3F3D" }}>원</RightMedium>
              </RightRowFrame>
            </RightRowFrame>
          </RightColFrame>
        </TableGroup>
      </InfoFrame>
      <SubContentFrame>
        <SubTitleFrame>
          <SubTitle>결제 요금</SubTitle>
        </SubTitleFrame>
        <TableFrame>
          <TableRow>
            <TableGroup style={{ width: "auto" }}>
              <TableLeftTitle>운행 거리</TableLeftTitle>
              <RightRowFrame>
                <RightMedium>{payload.distance}KM</RightMedium>
              </RightRowFrame>
            </TableGroup>
          </TableRow>
          {/* <TableGroup>
                        <TableLeftTitle>
                            부가 요금
                        </TableLeftTitle>
                        <RightColFrame>
                            <RightRowFrame>
                                <RightMedium86px style={{ marginBottom: "4px" }}>
                                    대기 요금
                                </RightMedium86px>
                                <RightReguler>20,000원</RightReguler>
                            </RightRowFrame>
                            <RightRowFrame>
                                <RightMedium86px style={{ marginBottom: "4px" }}>
                                    경유 요금
                                </RightMedium86px>
                                <RightColFrameMini>
                                    <RightReguler>10,000원</RightReguler>
                                </RightColFrameMini>
                            </RightRowFrame>
                            <RightRowFrame>
                                <RightMedium86px style={{ marginBottom: "4px" }}>
                                    홈서비스
                                </RightMedium86px>
                                <RightColFrameMini>
                                    <RightReguler>10,000원</RightReguler>
                                </RightColFrameMini>
                            </RightRowFrame>
                        </RightColFrame>
                    </TableGroup> */}
          <TableRow>
            <TableGroup style={{ width: "auto" }}>
              <TableLeftTitle>총 결제 금액</TableLeftTitle>
              <RightColFrame>
                <RightRowFrame style={{ gap: "10px", alignItems: "flex-end" }}>
                  <RightRowFrame style={{ alignItems: "flex-end" }}>
                    <PayTitle>{replacePrice(payload.payAmount)}</PayTitle>
                    <RightMedium style={{ marginBottom: "4px" }}>원</RightMedium>
                    <RightMedium style={{ marginBottom: "4px", marginLeft: "6px" }}> (부가세 포함)</RightMedium>
                  </RightRowFrame>
                </RightRowFrame>
              </RightColFrame>
            </TableGroup>
          </TableRow>
          <TableRow>
            <TableGroup style={{ width: "auto" }}>
              <TableLeftTitle><WordSkip />주문번호</TableLeftTitle>
              <RightRowFrame>
                <RightMedium>{payload.orderNo}</RightMedium>
              </RightRowFrame>
            </TableGroup>
          </TableRow>
          <TableRow>
            <TableGroup style={{ width: "auto" }}>
              <TableLeftTitle>결제 일시</TableLeftTitle>
              <RightRowFrame>
                <RightMedium>{cardPayload.timestamp.split(" ")[0].split("-")[0]}년 {cardPayload.timestamp.split(" ")[0].split("-")[1]}월 {cardPayload.timestamp.split(" ")[0].split("-")[2]}일 {cardPayload.timestamp.split(" ")[1].split(".")[0]}</RightMedium>
              </RightRowFrame>
            </TableGroup>
          </TableRow>
          <TableRow>
            <TableGroup style={{ width: "auto" }}>
              <TableLeftTitle>결제 수단</TableLeftTitle>
              <RightRowFrame>
                <RightMedium>{cardNo}</RightMedium>
              </RightRowFrame>
            </TableGroup>
          </TableRow>
        </TableFrame>
      </SubContentFrame>
      <ButtonLine>

      </ButtonLine>
    </ContentFrame>
  )
}




// <TableGroup>
//   <TableLeftTitle>
//     운행 요금
//   </TableLeftTitle>
//   <RightColFrame>
//     <RightRowFrame>
//       <RightMedium86px style={{ marginBottom: "4px" }}>
//         기본 요금
//       </RightMedium86px>
//       <RightReguler>{replacePrice(defaultPrice)}원</RightReguler>
//     </RightRowFrame>
//     <RightRowFrame>
//       <RightMedium86px style={{ marginBottom: "4px" }}>
//         긴급 배차
//       </RightMedium86px>
//       <RightColFrameMini>
//         <RightReguler>{replacePrice(emergency)}원</RightReguler>
//       </RightColFrameMini>
//     </RightRowFrame>
//     <RightRowFrame>
//       <RightMedium86px style={{ marginBottom: "4px" }}>
//         오지 요금
//       </RightMedium86px>
//       <RightColFrameMini>
//         <RightReguler>{replacePrice(outBack)}원</RightReguler>
//       </RightColFrameMini>
//     </RightRowFrame>
//     <RightRowFrame>
//       <RightMedium86px style={{ marginBottom: "4px" }}>
//         배차
//         <br />
//         취약시간
//       </RightMedium86px>
//       <RightColFrameMini>
//         <RightReguler>{replacePrice(danger)}원</RightReguler>
{/*      </RightColFrameMini>*/}
{/*    </RightRowFrame>*/}
{/*  </RightColFrame>*/}
{/*</TableGroup>*/}